import styled from 'styled-components'

import STYLE_GUIDE from '@/shared/constants/styleGuide'

const SupportListContainer = styled.div`
  @media screen and (min-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    margin: 0 auto 110px;
  }
  @media screen and (max-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    border-top: 1px solid ${STYLE_GUIDE.COLOR.grey01};
  }
`
const SupportListUl = styled.ul`
  @media screen and (min-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    border-top: 1px solid ${STYLE_GUIDE.COLOR.grey01};
    padding: 0;
    margin: 0;
  }
  @media screen and (max-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    padding: 0;
    margin: 0;
  }
`
const SupportListLi = styled.li`
  @media screen and (min-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    display: flex;
    align-items: center;
    height: 86px;
    border-bottom: 1px solid #ced6d8;
    &:hover {
      opacity: 0.7;
    }
  }
  @media screen and (max-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 68px;
    border-bottom: 1px solid #ced6d8;
    &:hover {
      opacity: 0.7;
    }
  }
`

const SupportListLiDate = styled.span`
  @media screen and (min-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    padding-inline-end: 5px;
    color: #a8b1b3;
  }
  @media screen and (max-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${STYLE_GUIDE.COLOR.grey03};
  }
`

const SupportListPagenation = styled.div`
  width: fit-content;
  margin: 40px auto 0;
`

export const SupportList = {
  SupportListContainer,
  SupportListUl,
  SupportListLi,
  SupportListLiDate,
  SupportListPagenation,
}
